import { lazy } from 'react';

const CircularitySentTransferConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/circularity/consult/sent-transfer',
			component: lazy(() => import('./SentTransferContainer'))
		}
	]
};

export default CircularitySentTransferConfig;
